import React from 'react';
import type { ScoreBand } from 'src/shared/components/risk-score-cell/riskScoreColour';

export type FactorScoreBarProps = {
    band: ScoreBand;
    isLoading?: boolean;
};

const BG_BY_BAND: Record<ScoreBand, string> = {
    1: 'bg-status-very-high-fg',
    2: 'bg-status-high-fg',
    3: 'bg-status-medium-fg',
    4: 'bg-status-low-fg',
    5: 'bg-status-very-low-fg',
};

const BAND_TO_VARIANT: Record<ScoreBand, string> = {
    1: 'very-poor',
    2: 'poor',
    3: 'moderate',
    4: 'good',
    5: 'very-good',
};

const FactorScoreBar = ({ band, isLoading = false }: FactorScoreBarProps) => {
    if (isLoading) {
        return (
            <div data-testid='factor-score-bar-skeleton' className='flex gap-1'>
                {Array.from({ length: 5 }).map((_, i) => (
                    <div key={i} className='h-2 bg-grey-20 rounded flex-1 animate-pulse' />
                ))}
            </div>
        );
    }

    const colorVariant = BAND_TO_VARIANT[band];
    const bgClass = BG_BY_BAND[band];

    return (
        <div className='flex gap-1'>
            {Array.from({ length: 5 }).map((_, i) => {
                const isBefore = i < band - 1;
                const isActive = i === band - 1;
                const isFilled = isBefore || isActive;

                const stepBgClass = isFilled ? bgClass : 'bg-muted';
                const stepBorderClass = isActive ? `border-2 border-reverse` : 'border-0';

                return (
                    <div
                        key={i}
                        data-testid='factor-score-step'
                        data-active={isActive}
                        data-filled={isFilled}
                        data-color-variant={colorVariant}
                        className={`flex-1 h-2 rounded-full ${stepBgClass} ${stepBorderClass}`}
                    />
                );
            })}
        </div>
    );
};

export default FactorScoreBar;
